module.exports = __webpack_public_path__ + "static/media/B-Rent.9695a121.png";